import React from "react";
import * as styles from "./CheckboxTeaser.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import CheckboxHelper from "@app/components/CheckboxHelper";

const CheckboxTeaser = (props) => {
	const { label, disabled = false } = props;

	return (
		<CheckboxHelper {...props}>
			{(inputProps) => {
				const className = classNames({
					[styles["checkbox-teaser"]]: true,
					[styles["is-active"]]: inputProps.isActive,
					[styles["is-disabled"]]: disabled,
					[props.className]: !!props.className,
				});

				return (
					<label htmlFor={props.id} className={className}>
						<div>{label}</div>
					</label>
				);
			}}
		</CheckboxHelper>
	);
};

CheckboxTeaser.propTypes = {
	label: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	id: PropTypes.string,
	name: PropTypes.string.isRequired,
	defaultValue: PropTypes.any,
	hasError: PropTypes.bool,
	onChange: PropTypes.func,
	children: PropTypes.func,
};

export default CheckboxTeaser;
